import { useState } from "react";
import { toast } from "sonner";
import { GraduationCap, Plus, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function EducationEditor({ education = [], onSaved }) {
  const [rows, setRows] = useState(education.map((e) => ({ ...e })));
  const [saving, setSaving] = useState(false);
  const [open, setOpen] = useState(false);
  const update = (i, patch) => setRows((rs) => rs.map((r, j) => (j === i ? { ...r, ...patch } : r)));

  const save = async () => {
    setSaving(true);
    try { const { data } = await api.patch("/talent/me", { education: rows }); setRows((data.education || []).map((e) => ({ ...e }))); toast.success("Pengalaman & pelatihan disimpan"); onSaved(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <details className="card-soft p-5" data-testid="education-editor" open={open} onToggle={(e) => setOpen(e.target.open)}>
      <summary className="cursor-pointer font-heading font-medium text-slate-800 inline-flex items-center gap-2"><GraduationCap size={16} strokeWidth={1.5} className="text-primary" />Pengalaman & Pelatihan</summary>
      <p className="mt-2 text-sm text-slate-500 leading-relaxed">Tampil di profil publik, mis. pendidikan, pelatihan pendengar, atau pengalaman relawan. Maks. 6 baris.</p>
      <div className="mt-4 space-y-3">
        {rows.map((r, i) => (
          <div key={i} className="flex items-start gap-2" data-testid={`education-row-${i}`}>
            <div className="flex-1 grid gap-2 sm:grid-cols-2">
              <input className="input-soft h-10" placeholder="Judul (mis. Universitas Indonesia)" value={r.title} onChange={(e) => update(i, { title: e.target.value })} maxLength={120} data-testid={`education-title-${i}`} />
              <input className="input-soft h-10" placeholder="Keterangan (mis. 2022 - Sarjana Psikologi)" value={r.subtitle} onChange={(e) => update(i, { subtitle: e.target.value })} maxLength={160} data-testid={`education-subtitle-${i}`} />
            </div>
            <button type="button" onClick={() => setRows((rs) => rs.filter((_, j) => j !== i))} className="p-2 rounded-lg text-slate-400 hover:text-rose-600 hover:bg-rose-50 transition-colors" data-testid={`education-remove-${i}`} aria-label="Hapus"><X size={16} strokeWidth={1.5} /></button>
          </div>
        ))}
        {rows.length === 0 && <p className="text-xs text-slate-400" data-testid="education-empty">Belum ada.</p>}
      </div>
      <div className="mt-4 flex gap-2">
        {rows.length < 6 && <button type="button" onClick={() => setRows((rs) => [...rs, { title: "", subtitle: "" }])} className="btn-outline h-10 px-4 text-sm" data-testid="education-add"><Plus size={14} strokeWidth={1.5} />Tambah</button>}
        <button onClick={save} disabled={saving} className="btn-primary h-10 px-5" data-testid="education-save">{saving ? "Menyimpan..." : "Simpan"}</button>
      </div>
    </details>
  );
}
